import {
  Box, Typography, Tooltip, Grid, Stack, Button, FormControlLabel, Checkbox, Toolbar, Paper, TextField,
} from '@mui/material';
import DatePicker, {Calendar, DateObject} from "react-multi-date-picker";
import { useState, useContext, useEffect } from 'react';
import { GlobalContext } from '../App';
import { useNavigate } from 'react-router-dom';
import pager2 from '../images/pager2.png';
import { DataGrid, GridColDef, GridValueGetterParams} from '@mui/x-data-grid';
import SortableList from './SortableList';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
//********************************************************************************************************
let timer = false;
let x = window.innerWidth - 200;
const columns = [
  { field: 'id', headerName: 'Ref No', width: 110,
    renderCell: (params) => 
      params.row.id[0] === "G" ? params.row.timeRead === "" ? <Button>Mark Read</Button>: ""  : params.row.id
  },
  { field: 'dept', headerName: 'Department', width: x/5.5-20},
  { field: 'name', headerName: 'Name', width: x/6},
  { field: 'pagerNo', headerName: 'Device', width: x/10},
  { field: 'message', headerName: 'Message', width: x / 6 + 20,
      renderCell: (params) => <Box title={params.row.message} position="bottom">{ params.row.message}</Box>
  },
  { field: 'timeSent', headerName: 'Time Sent', width: x/7},
  { field: 'timeRead', headerName: 'Time Read', width: x/7},
  { field: 'indicator', headerName:"", width: x/25, 
    renderCell: (params) => 
      params.row.timeRead ? <i className="fa fa-circle w3-text-green" /> : <i className="fa fa-circle w3-text-red" />
  },
];

//********************************************************************************************************
function Pager(props) {
  const [ctx, setContext] = useContext(GlobalContext);
  let [rows, setRows] = useState(ctx.T.savedRows || {});
  let [state, setState] = useState({ today: new Date(), filterCBX: true, pagerNo: "", message: "", phoneType: "pagerAppPIN", tabIndex: 0 });
  const [person, setPerson] = useState({});
  const [service, setService] = useState();
  const [serviceList, setServiceList] = useState([]);
  const [dept, setDept] = useState();
  const [deptList, setDeptList] = useState([]);
  const navigate = useNavigate();

  //======================================================
  async function fillDeptList() {
    let result = [], _;
    if(ctx.T.user.pagingOnly) [result, _] = await ctx.T.post("pagingGroup", { domain: "nyuhs.org" });
    else [result, _] = await ctx.T.post("pagingList");
    setDeptList(result);
    setPerson({});
  }
  //======================================================
  function fillServiceList(obj, index, ar) {
    try {
      setDept(obj);
      setDeptList(ar);
      setServiceList(filterServices(obj));
      setPerson({});
    } catch (err) { }
  }
  //======================================================
  function filterServices(dept) {
    if (!state.filterCBX) return dept?.activities || [];
    let ar = [];
    try {
      let now = new DateObject();
      let dObj = new DateObject(state.today); dObj.hour = now.hour; dObj.minute = now.minute;
      let doy = dObj.dayOfYear;
      let dow = dObj.weekDay.index;
      let dowName = dObj.weekDay.name;
      let nowMin = 60 * dObj.hour + dObj.minute;
      let isHoliday = dept?.holidays?.includes(doy) || false;

      // console.log(doy, dowName, nowMin, isHoliday);

      dept?.activities.forEach(act => {
        if (!act[dowName]) return;
        if (isHoliday && act?.holidays === false) return;
        let time1Failed = false;
        try { time1Failed = failed(act.dailyDetails[dow].startTime, act.dailyDetails[dow].endTime, nowMin) } catch (err) { time1Failed = true; }
        let time2Failed = failed(act.startTime, act.endTime, nowMin);
        if (time1Failed && time2Failed) return;
        ar.push({ name: act.name, guid: act.guid });
      });
    } catch (err) { }
    return ar;

    function failed(startTime, endTime, nowMin) {
      let pastMN = false;
      try {
        let startMin = toMinutes(startTime);
        let endMin = toMinutes(endTime);
        if (endMin <= startMin) pastMN = true;
        if (startMin <= 0 || endMin <= 0) return false;
        if (pastMN) {
          if (nowMin > endMin && nowMin < startMin) return true;
        } else {
          if (nowMin < startMin) return true;
          if (nowMin > endMin) return true;
        }
      } catch (err) { console.log("Failed",err.message)}
      return false;
    }
    function toMinutes(time) {
      try {
        let hours = Number(time.slice(0, 2));
        let min = Number(time.slice(3));
        return 60* hours + min;
      } catch (err) { }
      return 0;
    }
  }
  //======================================================
  function refresh(event) {
    state.today = new Date();
    setDept(dept);
    setService(service);
    setState({ today: new Date(), filterCBX: true, pagerNo: "", message: "", phoneType: "pagerAppPIN", tabIndex: 0 });
    findOnCall(service);
  }
  //======================================================
  function handleChange(event) {
    try {
      if (event.toDate) {
        state.today = event.toDate();
        findOnCall(service);
      } else {
        event.preventDefault();
        if (event.target.type === "checkbox") {
          state[event.target.name] = !!!state[event.target.name];
          setPerson({});
          setServiceList(filterServices(dept));
        } else state[event.target.name] = event.target.value;
      }
      setState({ ...state });
    } catch (err) {}
  }
  //======================================================
  function clearPager() {
    state.pagerNo = "";
    state.message = "";
    delete state.name;
    setState({ ...state });
  }
  //======================================================
  async function saveMessage() {
    ctx.T.savedRows ??= {};
    let newMessage = {
      name: person.fullName,
      dept: dept?.info?.name,
      pagerNo: state.pagerNo,
      message: state.message,
      timeSent: new DateObject().format("MM/DD/YYYY HH:mm"),
      timeRead: "",
      action: state.phoneType,
    }

    let msgID = ctx.T.guid();
    ctx.T.savedRows[msgID] = newMessage;
    try {
      logMessage({ ...newMessage, sender: ctx.T.user.email, _id: String(msgID) });
      clearPager();
    } catch (err) { };
    setRows({ ...ctx.T.savedRows });
  }
  //======================================================
  async function sendMessage() {
    ctx.T.savedRows ??= {};
    let sendObj = {
      pagerNo: state.pagerNo,
      msg: state.message,
      action: "push"
    }
    let [_, msgID] = await ctx.T.formPost("https://pagerapp.amclogic.com/pager3.php", sendObj);

    if (Number(msgID) > 1) {      // 1 means that pager number was not found
      let newMessage = {
        name: person.fullName,
        dept: dept?.info?.name,
        pagerNo: state.pagerNo,
        // message: state.message.substring(0,50) + (state.message.length > 50 ? " ..." : ""),
        message: state.message,
        timeSent: new DateObject().format("MM/DD/YYYY HH:mm"),
        timeRead: ""
      }
      ctx.T.savedRows[msgID] = newMessage;
      try {
        logMessage({ ...newMessage, sender: ctx.T.user.email, _id: String(msgID) });
        clearPager();
      } catch (err) { };
    } else ctx.T.alert("Message failed to send.  Please check the pager number and try again")
    setRows({ ...ctx.T.savedRows });
  }
  //======================================================
  async function logMessage (msg) 
  {
    let [result, _] = await ctx.T.post("insertOne", { collection: "Message", doc: { firstStamp: Date.now(), ...msg } });
  }
  //======================================================
  async function showArchive() {
    navigate("/pager/messages");
  }
  //======================================================
  async function findOnCall(service) {
    setService(service);
    try {
      let dObj = new DateObject(state.today);
      let doy = dObj.dayOfYear;
      
      // Adjust doy to previous day until 7 AM
      let now = new DateObject();
      if (dObj.day == now.day && dObj.hour < 8) doy--;


      let [person, _] = await ctx.T.post("findOnCall", { id: dept._id, service: service.guid, doy: doy });
      setPerson(person);
      try {
        if (person.pagerAppPIN) {
          state.name = person.fullName + " " + (person.credentials || "");
          state.pagerNo = person.pagerAppPIN;
        } else {
          delete state.name;
          state.pagerNo = "";
        }
        setState({ ...state });
      } catch(err) {}
    } catch (err) { console.log(err.message)}
  }
  //======================================================
  function fillPagerNo(ev) {
    if (ctx.T.user.pagerOnly && ev.target.name != "pagerAppPIN") return;
    state.pagerNo = ev.target.value;
    state.phoneType = ev.target.name;
    if (ev.target.name === "pagerAppPIN") state.tabIndex = 0; else state.tabIndex = 1;
    setState({ ...state });
  }
  //======================================================
  function onTabChange(index,lastIndex,event) {
    state.phoneType = index === 0 ? "pagerAppPIN" : false;
    state.tabIndex = index;
    setState({ ...state });
  }
  //======================================================
  function newRow(label, dataSlug, minRows = 0, label2 = false, dataSlug2 = false) {
    return (<>
      <Grid item xs={3}>{label}</Grid>
      <Grid item xs={label2 === false ? 9 : 3}><TextField variant="outlined" size="small" multiline={minRows > 0 ? true : false} minRows={minRows}
        name={dataSlug} value={(person && person[dataSlug]) || ""}
        sx={{ width: "100%" }} onClick={ fillPagerNo} />
      </Grid>
      {label2 && <>
        <Grid item xs={dataSlug2===false?6:2} sx={{textAlign:'right',pr:0.5}}>{label2}</Grid>
        {dataSlug2 && <Grid item xs={4}><TextField variant="outlined" size="small" multiline={minRows > 0 ? true : false} minRows={minRows}
          name={dataSlug2} value={(person &&  person[dataSlug2]) || ""}
          sx={{ width: "100%" }}  onClick={ fillPagerNo} />
        </Grid>}
      </>}
    </>)
  }
  //======================================================
  useEffect(() => {
    fillDeptList();
    setState({...state});
  },[]);
  //======================================================
  
  return (<>
    <Stack direction="row" alignItems="center" sx={{ml:2,mt:1}}>
      <Box sx={{mr:2,whiteSpace: "nowrap"}}>Date:</Box>
      <DatePicker name="today" value={state.today} format="MM/DD/YYYY" onChange={handleChange} />
      <FormControlLabel control={<Checkbox name="filterCBX" value={true} onClick={handleChange} checked={state.filterCBX} />} label="Filter for time of day" sx={{ml:2}} />
      <Button sx={{ textAlign: 'center', width: "200px" }} onClick={refresh}>Refresh Date & Time</Button>
      <Box sx={{flexGrow:1}}></Box>
      {! ctx.T.user.hideMessaging && <Button variant='text' onClick={showArchive} sx={{mr:2}}>Archived Messages</Button>}
    </Stack>

    <Stack direction="row" alignItems="flex-start" justifyContent="flex-start" sx={{ p: 2 }}>
      <Stack direction="row" spacing={2}  sx={{width:500}}>
        <SortableList title="Departments" items={deptList} nameKey="info.name" classSel="w3-red" initialSelection={-1} onSelected={fillServiceList}
          sx={{ height: 600, width: 300, overflow: "auto", border: "2px solid", p: 0.5 }} />
        <SortableList title="Services" items={serviceList} /*onReset={setPerson}*/ nameKey="name"  classSel="w3-red" initialSelection={-1} onSelected={findOnCall}
          sx={{ height: 600, overflow: "auto", width: 200, border: "2px solid", p: 0.5 }} />
      </Stack>
      <Stack sx={{flexGrow:1}}>
        <Box elevation={10} square sx={{ mb: 2, mx: 3 }}>
          <Tabs onSelect={onTabChange} selectedIndex={state.tabIndex}>
            <TabList>
              <Tab >Pager App</Tab>
              {!ctx.T.user.pagerOnly && <Tab >Phone/Email</Tab>}
            </TabList>
          </Tabs>
          <Paper elevation={10} square >
            {state.phoneType === "pagerAppPIN" ? <Box className={ctx.bkSidebar2} align="center" p={1}>Send a Secure Pager App Message</Box>
            : <Box className="w3-flat-peter-river" align="center" p={1}>Log a Manually Sent Message</Box>}
            <Box sx={{ p: 3, position:"relative" }}>
              <Button variant="text" size="small" onClick={clearPager} sx={{position:"absolute", top:0,right:0}}>clear</Button>
              <Stack direction="row" justifyContent="center" pb={1}>
                <TextField label={state.phoneType === "pagerAppPIN" ? "Pager": "Phone / Email"} size="small" name="pagerNo" value={state.pagerNo} onChange={handleChange} sx={{mr:1}} />
                {state.phoneType === "pagerAppPIN" ? <Button variant='contained' color="success"onClick={sendMessage} sx={{width:200}}>Send Pager Message</Button>
                : <Button variant='contained' className="w3-flat-peter-river" onClick={saveMessage} sx={{width:200}}>Save</Button>}
              </Stack>
              <TextField label="Message" size="small" rows={3} multiline fullWidth name="message" value={state.message} onChange={handleChange} />
            </Box>
          </Paper>
        </Box>

        <Box sx={{ mx:3}}>
          <Grid container spacing={0} sx={{ px:1, border: 1, py:1}}>
            {newRow("Full Name", "fullName",0,"E-mail", "email")}
            {newRow("Cell Phone", "cellPhone", 0, "Office Phone", "officePhone")}
            {newRow("PagerApp PIN", "pagerAppPIN", 0, "Home Phone", "homePhone")}
            <Grid item xs={3}>Notes</Grid>
            <Grid item xs={9}><TextField variant="outlined" size="small" multiline minRows={2} value={(person?.howToCall || "") + " " + (person?.notes || "")}
              sx={{ width: "100%" }} />
            </Grid>
          </Grid>
        </Box>
        <Box component="b" sx={{mx:3,mt:1}}>Instructions</Box>
        <TextField sx={{mx:3}} size="small" rows={3} multiline value={dept?.info?.notes || ""}/>
      </Stack>
    </Stack>

    <MessageList messages={rows}/>
  </>)
}
//********************************************************************************************************


//********************************************************************************************************
function MessageList(props) {
  const [ctx, setContext] = useContext(GlobalContext);
  let [state, setState] = useState({ hideViewed: false});
  let [rows, setRows] = useState(props.messages || []);

  //======================================================
  function handleChange(event) {
    try {
      event.preventDefault();
      if (event.target.type === "checkbox") {
        state[event.target.name] = !!!state[event.target.name];
      } else state[event.target.name] = event.target.value;
      setState({ ...state });
    } catch (err) { console.log("handleChange",err.message)}
  }
  //======================================================
  async function gridCellClick(obj) {
    if (obj.field == "id") try {
      rows[obj.id].timeRead = ctx.U.logTimeRead(obj.id, new DateObject());
    setRows({ ...rows });
    } catch(err) {}
    if (obj.field == "message") try {
      ctx.T.alert(obj.row.message,"Message")
    } catch(err) {}
  }
  //======================================================
  async function getViewTime() {
    let rows = await ctx.U.getViewTime(ctx.T.savedRows);  // setInterval calls getViewTime with data as it existed on call time which is out of date.  Using savedRows fixes it.
    setRows({ ...rows });
	}
  //======================================================
  useEffect(() => {
    try { clearInterval(timer)} catch(err) {}
    timer = setInterval(getViewTime, 15000);
    return () => {try {clearInterval(timer)} catch (err) { } }
  },[]);
  //======================================================
  useEffect(() => {
    setRows(props.messages);
  },[props.messages]);
  //======================================================

  return (<>
    {!ctx.T.user.hideMessaging && <>
      <Stack direction="row" className={ctx.bkSidebar2} py={0} justifyContent="space-between" alignItems="center" sx={{ mx: 2, px: 1 }}>
        <Typography variant="h5" p={0}>Messages Sent</Typography>
        <FormControlLabel control={<Checkbox name="hideViewed" className={ctx.bkSidebar2} value={true} onClick={handleChange} checked={state.hideViewed} />} label="Hide viewed" sx={{ ml: 2 }} />
      </Stack>

      <Box sx={{ m: 5, width: 'auto', height: 400 }}>
        <DataGrid
          rows={Object.entries(rows).map(([key, row]) => ({ ...row, id: key })).filter((row) => !state.hideViewed || ctx.T.isBlank(row.timeRead))}
          columns={columns}
          className={"w3-white"}
          onCellClick={gridCellClick}
          initialState={{
            sorting: {
              sortModel: [{ field: "timeSent", sort: "desc" }],
            },
          }}
          autoPageSize
        />
      </Box>
    </>}
  </>)
}
//********************************************************************************************************
export default Pager;